import { useEffect, useState } from 'react';

interface HeaderProps {
  onRegisterClick: () => void;
}

export default function Header({ onRegisterClick }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'О конференции', href: '#about' },
    { label: 'Программа и спикеры', href: '#program' },
    { label: 'Стендап', href: '#standup' },
    { label: 'Как попасть', href: '#how-to-get' },
  ];

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`hidden md:block fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-20">
        <div className="flex items-center gap-3">
          <div
            className={`hidden lg:block text-xs ${
              scrolled ? 'text-gray-500' : 'text-white/80'
            } leading-tight`}
          >
            <div>16-17 апреля 2026</div>
            <div>Санкт-Петербург</div>
          </div>
        </div>

        <nav className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap border-b-2 border-transparent hover:border-[#c8963e] pb-0.5 ${
                scrolled ? 'text-[#0f3d32]' : 'text-white'
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={onRegisterClick}
            className="hidden md:block bg-[#e8a030] text-white text-sm font-bold px-6 py-2.5 rounded-full hover:bg-[#f0aa35] transition-all hover:-translate-y-0.5 hover:scale-105 whitespace-nowrap cursor-pointer"
            style={{ boxShadow: '0 2px 14px 0 rgba(232,160,48,0.4)' }}
          >
            Зарегистрироваться
          </button>
        </div>
      </div>
    </header>
  );
}
